module.exports = __webpack_public_path__ + "static/media/pepsi.fc5444d3.glb";